module.exports = __webpack_public_path__ + "static/media/image1.abcd29a6.svg";